import {h} from 'preact';
import {createPortal} from 'preact/compat';
import {Switch} from "antd";
import designService from "../service/designService";
import store from "../store";
import * as actions from "../actions";
import { CloseOutlined, LinkOutlined } from '@ant-design/icons';
import "antd/lib/tooltip/style/index.css";
import constants from '../constants';
import PaintBrushIcon from './icon/PaintBrushIcon';
import DisplayIcon from './icon/DisplayIcon';
import { useState } from 'preact/hooks';

export function DataSettingsModal({designId, open, onModalClose, dsaAutoSyncEnabled, posAutoSyncEnabled, linksAutoSyncEnabled}) {

  const [isLoading, setIsLoading] = useState(false);

  function toggleDesignsSync() {
    const value = !posAutoSyncEnabled;
    store.dispatch(actions.setPosAutoSyncEnabled(value));
    if (!value) {
      store.dispatch(actions.setDsaAutoSyncEnabled(false));
      store.dispatch(actions.setLinksAutoSyncEnabled(false));
    }
    designService.togglePOSAutoSync(designId)
  }

  function toggleDisplaySync() {
    const value = !dsaAutoSyncEnabled;
    if (!posAutoSyncEnabled) {
      store.dispatch(actions.setPosAutoSyncEnabled(true));
    }
    store.dispatch(actions.setDsaAutoSyncEnabled(value));
    designService.toggleDSAAutoSync(designId, value)
  }
  
  function toggleLinksSync() {
    const value = !linksAutoSyncEnabled;
    if (!posAutoSyncEnabled) {
      store.dispatch(actions.setPosAutoSyncEnabled(true));
    }
    store.dispatch(actions.setLinksAutoSyncEnabled(value));
    designService.toggleLinksAutoSync(designId, value)
  }

  return open ? createPortal(<div>
    <div className="modal-back" onClick={onModalClose}/>
    <div className="modal data-settings-modal">
      <header>
        <CloseOutlined onClick={onModalClose}/>
        <h2>POS Sync Controls</h2>
      </header>
      
      <section className="sync-option" style={{paddingTop: 0}}>
        <div className="sync-row">
          <span className="icon"><PaintBrushIcon /></span>
          <h3>Designs</h3>
          <div className="sync-toggle">
            <Switch checked={posAutoSyncEnabled} onChange={toggleDesignsSync} size="small" loading={isLoading} />
          </div>
        </div>
        <div className="sync-description">
          POS data flows automatically to designs
        </div>
      </section>

      <section className="sync-option">
        <div className="sync-row">
          <span className="icon display"><DisplayIcon fill="#222" /></span>  
          <h3>Display</h3>
          <div className="sync-toggle">
            <Switch checked={dsaAutoSyncEnabled} onChange={toggleDisplaySync} size="small" loading={isLoading} />
          </div>
        </div>
        <div className="sync-description">
          POS data flows automatically to Display App
        </div>
      </section>

      <section className="sync-option">
        <div className="sync-row">
          <span className="icon"><LinkOutlined /></span>
          <h3>Links</h3>
          <div className="sync-toggle">
            <Switch checked={linksAutoSyncEnabled} onChange={toggleLinksSync} size="small" loading={isLoading} />
          </div>
        </div>
        <div className="sync-description">
          POS data flows automatically to share links, embeds, and QR Codes
        </div>
      </section>
    </div>
  </div>, document.getElementById('modals')) : null;
}
